import loadable from "@loadable/component";

export const Login = loadable(() => import("./login"), {
  resolveComponent: ({ Login }) => Login,
});

export const Register = loadable(() => import("./register"), {
  resolveComponent: ({ Register }) => Register,
});

export const Dashboard = loadable(() => import("./dashboard"), {
  resolveComponent: ({ Dashboard }) => Dashboard,
});

export const ObjectsPage = loadable(() => import("./objects"));
